"use strict";

define('uikit/views/error',['underscore', 'backbone', 'marionette', '../mixins/component.mixin', '../templates'], function (_, Backbone, Mn, ComponentMixin, Templates) {
  var ErrorView = Mn.ItemView.extend(ComponentMixin).extend({
    tagName: 'p',
    className: 'ui red icon header',
    options: {
      text: 'An unexpected error has occured.',
      visible: false,
      subText: '',
      inverted: false
    },
    update: {
      inverted: false
    },
    template: Templates.UIKit['error_helper'],
    updateAttributes: function updateAttributes() {
      this.addClass('inverted', this.getBoolOption('inverted'));
    }
  });
  return ErrorView;
});

